import React from 'react';
import { Dialog, Typography, Box } from '@mui/material';
import { Icons } from '@/icons';

// Icons used for the GamicsDialog
const { Trash, Approved, Rejected } = Icons;

// This color is for the background gray behind the icons
// width 231px height 231px of the background gray behind the icons and border radius is 200px

interface GamicsDialogProps {
  open: boolean;
  onClose: () => void;
  type: 'removed' | 'approved' | 'rejected' | "hold" | 'publish';
}

const GamicsDialog: React.FC<GamicsDialogProps> = ({ open, onClose, type }) => {
  let icon;
  let heading;
  let subheading;

  // Set dialog content based on type
  if (type === 'removed') {
    icon = <Trash  />;
    heading = 'Gamic Removed!';
    subheading = 'Gamic is removed from the history';
  } else if (type === 'approved') {
    icon = <Approved/>;
    heading = 'Gamic Approved!';
    subheading = 'Gamic is approved by admin';
  } else if (type === 'rejected') {
    icon = <Rejected  />;
    heading = 'Gamic Rejected!';
    subheading = 'Gamic is not approved by admin';
  } else if (type === 'publish') {
    icon = <Icons.Republish  />;
    heading = 'Gamic Re Publish!';
    subheading = 'Gamic is Re Publish by admin';
  }
  else if (type === 'hold') {
    icon = <Icons.HoldB />;
    heading = 'Gamic on Hold!';
    subheading = 'Gamic is temporarily on hold';
  } else {
    return null; // If type is not recognized, do not render the dialog
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '24px', padding: '30px' } }}>
      <Box display="flex" flexDirection="column" alignItems="center" pt={2} pb={4}>
        <Box
          sx={{
            width: '231px',
            height: '231px',
            borderRadius: '50%',
            bgcolor: '#D9D9D9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          {icon}
        </Box>
        <Typography sx={{ fontSize: 40, fontWeight: 'bold' }} align="center" gutterBottom>
          {heading}
        </Typography>
        <Typography sx={{ fontSize: 18, color: '#515151' }} align="center">
          {subheading}
        </Typography>
      </Box>
    </Dialog>
  );
};

export default GamicsDialog;
